import posthog from 'posthog-js';
import { readTenantFromCookie } from '@decent-kit/next-shared/tenant';

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

if (
  typeof window !== 'undefined' &&
  token &&
  !token.startsWith('__NEXT_RUNTIME') &&
  !window.location.hostname.includes('localhost') &&
  !window.location.hostname.includes('127.0.0.1')
) {
  const tenant = readTenantFromCookie();
  posthog.init(token, {
    // First-party reverse proxy (see next.config.ts rewrites) so events aren't
    // blocked by ad blockers; ui_host points links back to the PostHog app.
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    // Session replay is disabled to control PostHog billing (recordings are
    // billed separately and dominate cost). Keep it off in project settings too.
    disable_session_recording: true,
    // Trim high-volume, low-value auto-capture to cut billed event count.
    // $pageview/$pageleave stay on for core traffic analytics; the funnels we
    // care about are captured explicitly via trackEvent().
    autocapture: false,
    capture_heatmaps: false,
    capture_dead_clicks: false,
    capture_performance: { web_vitals: false },
    // Multi-tenant: scope the cookie to the exact subdomain so a distinct_id
    // can't leak across tenant subdomains sharing a root (e.g. *.decentkit.app).
    cross_subdomain_cookie: false,
    loaded: (ph) => {
      // Tag every event with the active tenant group (once — repeat group()
      // calls each emit a billable $groupidentify event).
      if (tenant && ph.getGroups()?.tenant !== tenant) {
        ph.group('tenant', tenant, { name: tenant });
      }
      // Identify the logged-in user so events attribute to the person. Gate on a
      // changed distinct_id so we don't emit a redundant $identify every load.
      fetch('/api/auth/session', { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          const user = data?.user;
          if (!user?.id || ph.get_distinct_id() === user.id) return;
          ph.identify(user.id, { email: user.email, name: user.displayName });
        })
        .catch(() => {
          // Network/auth hiccup — continue unattributed rather than throw.
        });
    },
  });
}
